import styled, { keyframes, css } from 'styled-components';
import { _DivProps, _ElementProps } from 'styles/base';

const appearFromLeft = keyframes`
  from{
    opacity: 0;
    transform: translateX(-150px);
  } to {
    opacity: 1;
    transform: translateX(0px);
  }
`;

const appearFromRight = keyframes`
  from{
    opacity: 0;
    transform: translateX(150px);
  } to {
    opacity: 1;
    transform: translateX(0px);
  }
`;

interface GridItemProps extends _ElementProps {
  $delay?: number;
  $duration?: number;
}

interface SecundaryProps extends _DivProps {
  $active: boolean;
}

export const Content = styled.div<_DivProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  min-height: calc(100vh - 190px);

  /* overflow-x: hidden; */

  h2 {
    font-size: 24px;
    margin: 15px 0 0 0;
  }

  form {
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    > button {
      margin: 35px;
    }

    figure,
    div,
    span {
      > p {
        width: 100%;
        text-align: left;
        color: #8a0002;
        font-family: 'Roboto Slab', serif;
        font-size: 16px;
        font-weight: 500;
      }
    }

    figure {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 10px;
      padding: 10px;
      border: 2px solid #efefef;
      border-radius: 5px;
      background: #fff;
      box-shadow: 2px 5px 10px 3px rgba(0, 0, 0, 0.5);

      opacity: 0;
      transform: translateX(150px);

      animation: ${appearFromRight} 1s ease forwards;
    }
  }

  @media screen and (max-width: 900px) {
    min-height: calc(100vh - 190px);
  }

  @media screen and (max-width: 400px) {
    form {
      figure {
        width: 100vw;
        border-radius: 0px;
      }
    }
  }
`;

export const GridContainer = styled.div<_DivProps>`
  /* margin: 10px; */
  display: grid;
  grid: auto / 1fr 1fr 1fr 1fr;
  column-gap: 35px;
  row-gap: 25px;
  position: relative;
  z-index: 51;

  @media screen and (max-width: 1620px) {
    grid: auto / 1fr 1fr 1fr;
  }

  @media screen and (max-width: 1200px) {
    grid: auto / 1fr 1fr;
  }

  @media screen and (max-width: 800px) {
    grid: auto / 1fr;
  }
`;

export const NacHeader = styled.figure<_ElementProps>`
  @media screen and (max-width: 400px) {
    width: 100vw;
    border-radius: 0px;
  }
`;

export const AnimatedSection = styled.section<GridItemProps>`
  /* height: 100%; */

  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 5px 10px 10px 10px;
  border: 2px solid #efefef;
  border-radius: 5px;
  background: #fff;
  box-shadow: 2px 5px 10px 3px rgba(0, 0, 0, 0.5);
  opacity: 0;
  transform: translateX(-150px);

  animation: ${appearFromLeft} ${({$duration}) => $duration || 1}s ease forwards;

  ${({$delay}) =>
    $delay &&
    css`
      animation-delay: ${$delay}s;
    `}

  > span + span {
    margin: 5px 0 0 0;
  }

  @media screen and (max-width: 400px) {
    width: 100vw;
    border-radius: 0px;
  }
`;

export const SecundaryAddress = styled.div<SecundaryProps>`
  pointer-events: none;
  height: 0px;
  opacity: 1;
  overflow: hidden;

  transition: height 0.5s, opacity 5s;

  ${({$active}) =>
    $active &&
    css`
      opacity: 1;
      pointer-events: all;
      height: 545px;
    `}
`;
